import { render, staticRenderFns } from "./LmPagination.vue?vue&type=template&id=49c75f6e&scoped=true"
import script from "./LmPagination.vue?vue&type=script&lang=js"
export * from "./LmPagination.vue?vue&type=script&lang=js"
import style0 from "./LmPagination.vue?vue&type=style&index=0&id=49c75f6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c75f6e",
  null
  
)

export default component.exports